/** Trilha de auditoria (T-08) e configurações da empresa. */
const en = {
  'nav.license': 'License',
  'audit.title': 'Audit trail',
  'audit.sub': 'Everything done in the platform, with who, when, from where and on which object. Each record is chained to the previous one by a hash.',
  'audit.verify': 'Verify the chain',
  'audit.verifying': 'Recalculating the chain of every record…',
  'audit.siem': 'Send to the SIEM',
  'audit.v.read': 'Read {count} records',
  'audit.v.chain': 'Recalculate the hash chain of each record',
  'audit.v.noBreak': 'No break found',
  'audit.v.brokenAt': 'Break found at record {id}',
  'audit.v.intact': 'Trail intact: none of the {count} records was changed.',
  'audit.v.broken': 'The chain is broken at record {id}: a record was changed outside Hive. Keep the evidence and contact the service provider.',
  'audit.f.actor': 'Person or account',
  'audit.f.actorPlaceholder': 'E.g. marina.castro@aurora.example',
  'audit.f.action': 'Action',
  'audit.f.target': 'Object',
  'audit.empty': 'No records with these filters.',
  'audit.col.when': 'Date and time',
  'audit.col.who': 'Who',
  'audit.col.action': 'Action',
  'audit.col.object': 'What',
  'audit.col.ip': 'Origin (IP)',
  'audit.col.chain': 'Chain',
  'audit.note': 'Each record keeps the fingerprint of the previous one. Any direct change in the database breaks the chain and shows up in the verification.',
  'audit.group.user': 'People',
  'audit.group.profile': 'Profiles',
  'audit.group.auth': 'Sign-in methods',
  'audit.group.integration': 'Integrations',
  'audit.group.api-account': 'Integration accounts (API)',
  'audit.group.settings': 'Company settings',
  'audit.group.support': 'Support access',
  'audit.group.config': 'Configuration versions',
  'audit.group.group-mappings': 'Directory groups',
  'audit.group.template': 'Templates',
  'audit.target.user': 'Person',
  'audit.target.profile': 'Profile',
  'audit.target.auth-method': 'Sign-in method',
  'audit.target.integration': 'Integration',
  'audit.target.api-account': 'Integration account',
  'audit.target.settings': 'Settings',
  'audit.target.support-request': 'Support request',
  'audit.target.template': 'Template',
  'audit.target.tenant': 'Company',
  'audit.kind.integration': 'integration account',
  'audit.kind.provider': 'service provider',
  'audit.kind.system': 'system',
  'audit.action.user.invited': 'Person invited',
  'audit.action.user.invite-resent': 'Invite sent again',
  'audit.action.user.first-login': 'First sign-in',
  'audit.action.user.profiles-changed': 'Profiles of a person changed',
  'audit.action.user.profile-switched': 'Active profile switched',
  'audit.action.user.disabled': 'Access disabled',
  'audit.action.user.enabled': 'Access turned back on',
  'audit.action.profile.created': 'Profile created',
  'audit.action.profile.updated': 'Profile changed',
  'audit.action.profile.deleted': 'Profile deleted',
  'audit.action.config.restored': 'Version restored',
  'audit.action.auth.method-enabled': 'Sign-in method turned on',
  'audit.action.auth.method-disabled': 'Sign-in method turned off',
  'audit.action.integration.connected': 'Integration connected',
  'audit.action.integration.updated': 'Integration changed',
  'audit.action.integration.disconnected': 'Integration disconnected',
  'audit.action.integration.use-enabled': 'Use turned on',
  'audit.action.integration.use-disabled': 'Use turned off',
  'audit.action.integration.consent-granted': 'Extra permission granted',
  'audit.action.integration.tested': 'Connection tested',
  'audit.action.api-account.created': 'Integration account created',
  'audit.action.api-account.rotated': 'Token switched',
  'audit.action.api-account.revoked': 'Integration account revoked',
  'audit.action.settings.updated': 'Company settings changed',
  'audit.action.settings.logo-uploaded': 'Company logo uploaded',
  'audit.action.settings.logo-removed': 'Company logo removed',
  'audit.action.settings.icon-uploaded': 'Brand icon uploaded',
  'audit.action.settings.icon-removed': 'Brand icon removed',
  'audit.action.support.requested': 'Support access requested',
  'audit.action.support.approved': 'Support access approved',
  'audit.action.support.denied': 'Support access denied or revoked',
  'audit.action.support.call': 'Call made in support mode',
  'audit.action.group-mappings.updated': 'Directory groups changed',
  'audit.action.template.duplicated': 'Template duplicated',
  'audit.action.tenant.created': 'Company created',

  'settings.title': 'Company settings',
  'settings.sub': 'Brand and default language of the company. The data region and plan are set by the service provider.',
  'settings.brand': 'Brand',
  'settings.companyName': 'Company name',
  'settings.companyNameHint': 'Shown in the top bar, on the home page and on the sign-in page. For now it is typed here; later it will come from the license.',
  'settings.productName': 'Product name shown',
  'settings.productNameHint': 'Appears in the top bar, the sign-in page and the browser tab.',
  'settings.logo': 'Logo address (optional)',
  'settings.logoHint': 'An https:// address of a PNG or SVG image. Without a logo, the product name is shown in letters.',
  'settings.logoInvalid': 'Use an address that starts with https://',
  'settings.logoAfterSave': 'The new logo appears after you save: Hive fetches it from this address and serves it from the console itself (PNG, JPEG, WebP, GIF or SVG up to 512 KB).',
  'settings.color': 'Main color',
  'settings.swatch': 'Color {color}',
  'settings.other': 'Other:',
  'settings.contrastLow': 'Not enough contrast with white text ({ratio}:1).',
  'settings.contrastFix': 'Buttons and the top bar are hard to read (AA minimum: 4.5:1). The closest variation that meets it is {color}.',
  'settings.useSuggestion': 'Use the suggested variation',
  'settings.contrastOk': 'AA contrast OK ({ratio}:1)',
  'settings.langTitle': 'Language',
  'settings.lang': 'Default language of the company',
  'settings.langHint': 'New people start in this language; each person can choose another in the user menu.',
  'settings.save': 'Save settings',
  'settings.saveHint': 'The change applies right away and goes to the audit trail.',
  'settings.saved': 'Settings saved.',
  'settings.undone': 'Previous settings restored.',
  'settings.preview': 'Live preview',
  'settings.previewHint': 'In dark mode Hive uses a lighter version of the color to keep the contrast.',
  'settings.logoFull': 'Full logo',
  'settings.logoFullHint': 'Wide image for the sign-in page, dashboards and the header of PDF reports. Recommended: about 600 x 150 px (4:1), PNG or SVG with a transparent background, up to 512 KB.',
  'settings.icon': 'Icon',
  'settings.iconHint': 'Square image for the navigation rail and the browser tab. Recommended: 256 x 256 px, PNG or SVG, up to 256 KB. Without an icon, the rail shows the initial of the product name on the brand color.',
  'settings.iconCurrent': 'Current icon',
  'settings.iconNone': 'No icon: initial of the name',
  'settings.iconRemove': 'Remove icon',
  'settings.iconUploaded': 'Icon uploaded',
  'settings.iconRemoved': 'Icon removed',
  'settings.iconTooBig': 'Use an image up to 256 KB.',
  'settings.where': 'Where each image appears',
  'settings.whereSignIn': 'Sign-in page (full logo)',
  'settings.whereSignInBtn': 'Sign in',
  'settings.whereRail': 'Navigation rail and browser tab (icon)',
  'settings.whereRailIcon': 'Company icon',
  'settings.whereRailInitial': 'No icon: initial on the brand color',
  'settings.whereReport': 'Report header (full logo)',
  'settings.whereReportTitle': 'Assets by operating system',
  'license.title': 'License',
  'license.sub': 'Deployment mode, trial period and the agents allowed by the license of this installation.',
  'license.mode': 'Deployment mode',
  'license.mode.demo': 'Demo',
  'license.mode.trial': 'Trial',
  'license.mode.production': 'Production',
  'license.state.demo': 'Demo installation: no agent limit',
  'license.state.trial': 'Trial: {days} days left',
  'license.state.grace': 'Trial ended: {days} days of grace left',
  'license.state.expired': 'Trial ended: read-only',
  'license.state.licensed': 'Licensed',
  'license.state.unlicensed': 'No valid license: read-only',
  'license.installationId': 'Installation ID',
  'license.installationIdHint': 'Give this ID (or the company address) to the vendor to get a key bound to this installation.',
  'license.firstBoot': 'Installed on',
  'license.trialEnds': 'Trial ends on',
  'license.graceEnds': 'Grace ends on',
  'license.usage': 'Agents in use',
  'license.usageOf': '{used} of {limit} agents',
  'license.usageUnlimited': '{used} agents (no limit in demo mode)',
  'license.usageNear': 'Over 90% of the license is in use. Plan an add-on key before new machines arrive.',
  'license.usageFull': 'All the agents allowed are in use: new agents are refused until you install an add-on key or revoke agents of machines that left. The installed agents keep working.',
  'license.collectorNote': 'Collectors do not use licenses.',
  'license.total': 'Total licensed',
  'license.totalValue': '{count} agents',
  'license.install': 'Install a license key',
  'license.serial': 'License key',
  'license.serialHint': 'Paste the whole key the vendor sent, starting with HIVE1. Line breaks are ignored.',
  'license.installBtn': 'Install key',
  'license.installing': 'Checking the key…',
  'license.installed': 'License key installed.',
  'license.notSerial': 'This does not look like a license key: it starts with HIVE1. and has two dots.',
  'license.keys': 'Installed keys',
  'license.noKeys': 'No license key installed yet.',
  'license.col.id': 'License',
  'license.col.licensee': 'Licensee',
  'license.col.agents': 'Agents',
  'license.col.kind': 'Kind',
  'license.col.validUntil': 'Valid until',
  'license.col.state': 'State',
  'license.col.installed': 'Installed',
  'license.kind.new': 'New',
  'license.kind.add-on': 'Add-on',
  'license.key.active': 'Active',
  'license.key.pending': 'Not started',
  'license.key.expired': 'Expired',
  'license.key.replaced': 'Replaced',
  'license.replacedBy': 'Replaced by {id}',
  'license.startsOn': 'Starts on {date}',
  'license.perpetual': 'No expiry',
  'license.adminOnly': 'Only administrators see and install the keys.',
  'license.readOnlyNote': 'Read-only: the data stays available, but new agents and changes are blocked until a valid license is installed.',
  'license.stackNote': 'Valid keys add up. A key that replaces another takes the old one out of the count.',
  'license.banner.demo': 'Demo installation: lab data, not for production use.',
  'license.banner.trial': 'Trial: {days} days left.',
  'license.banner.grace': 'The trial ended. {days} days of grace left before the system becomes read-only: install a license.',
  'license.banner.expired': 'The trial ended and the system is read-only: install a license to add agents and make changes.',
  'license.banner.unlicensed': 'This installation has no valid license and is read-only: install a license key.',
  'license.banner.full': 'License full: {used} of {limit} agents in use. New agents are refused.',
  'license.banner.near': 'License almost full: {used} of {limit} agents in use.',
  'license.banner.open': 'See the license',
  'audit.action.license.installed': 'License key installed',
  'audit.action.deployment.mode-changed': 'Deployment mode changed',
  "settings.logoUpload": "Upload image",
  "settings.logoReplace": "Replace image",
  "settings.logoRemove": "Remove",
  "settings.logoCurrent": "Current logo",
  "settings.logoFileHint": "PNG, JPEG, WebP or SVG up to 512 KB. It applies right away, also on the sign-in page.",
  "settings.logoOrUrl": "Or logo address (https)",
  "settings.logoUploaded": "Logo uploaded",
  "settings.logoRemoved": "Logo removed",
  "settings.logoTooBig": "Use an image up to 512 KB.",
  "users.tab.teams": "Teams",
  "teams.lead": "Groups of people to share dashboards with whoever works together.",
  "teams.new": "New team",
  "teams.empty": "No teams yet",
  "teams.emptyText": "Create a team to share dashboards with several people at once.",
  "teams.col.name": "Name",
  "teams.col.members": "People",
  "teams.col.people": "Who",
  "teams.col.actions": "Actions",
  "teams.edit": "Edit",
  "teams.delete": "Delete",
  "teams.deleted": "Team deleted",
  "teams.deleteTitle": "Delete the team {name}?",
  "teams.deleteText": "Dashboards shared with this team stop showing to its people (unless shared with them directly).",
  "teams.editTitle": "Team {name}",
  "teams.description": "Description",
  "teams.members": "People in the team ({n})",
  "teams.searchPeople": "Search people",
  "teams.save": "Save",
  "teams.saved": "Team saved",
  "rp.d.sharePeople": "People and teams I choose",
  "rp.d.teams": "Teams ({n})",
  "rp.d.people": "People ({n})",
  "rp.d.noTeams": "No teams yet: create them in Admin › People › Teams.",
  "rp.d.searchPeople": "Search people",
  // G10 · pacote de evidências e escopo do plano de controle
  "audit.evidence": "Evidence pack",
  "audit.evidenceText": "Signed ZIP for SOC 2 / ISO 27001 auditors: the chained audit trail of the period with the chain verification, configuration changes, privileged access (provider support, dual approvals, revealed secrets, MFA), the current access review and every backup with its sha256. The manifest is signed with Ed25519.",
  "audit.evidenceFrom": "From",
  "audit.evidenceTo": "To",
  "audit.evidenceDate": "Use YYYY-MM-DD.",
  "audit.evidenceRun": "Generate signed pack",
  "audit.evidenceBusy": "Generating…",
  "audit.evidenceDone": "Evidence pack downloaded. The export went to the audit trail.",
  "scope.control-plane": "Provider control plane (managed instance: status, usage, support requests)",
  "nav.health": "Installation health",
  "ih.title": "Installation health",
  "ih.sub": "Checks of what this installation needs from the infrastructure, run from the core.",
  "ih.turn.title": "Remote access relay (TURN)",
  "ih.turn.lead": "Remote access only connects through the relay. The test asks for a TURN allocation on each published address, over UDP and TCP, with the same short-lived credential the console and the agent use.",
  "ih.turn.published": "Published addresses",
  "ih.turn.run": "Test the relay",
  "ih.turn.running": "Testing…",
  "ih.turn.off": "Remote access is turned off on this installation (relay turn-desativado.invalid). To turn it on, follow the infrastructure checklist below.",
  "ih.turn.col.address": "Address",
  "ih.turn.col.port": "Port answers",
  "ih.turn.col.alloc": "TURN allocation",
  "ih.turn.col.detail": "Detail",
  "ih.turn.yes": "Yes",
  "ih.turn.no": "No",
  "ih.turn.allocated": "Allocated in {ms} ms",
  "ih.turn.failed": "Failed",
  "ih.turn.relayed": "relayed address {a}",
  "ih.turn.allOk": "The relay answers over UDP and TCP: remote access can connect.",
  "ih.turn.partial": "Part of the relay addresses failed: sessions may end in \"connection failed\". See the detail of each line.",
  "ih.turn.at": "Tested {when}.",
  "ih.turn.checklist": "Infrastructure checklist",
  "ih.turn.ck.name": "Public name or IP for the relay (HIVE_TURN_HOST), reachable by the technicians' browsers and by the agents.",
  "ih.turn.ck.port": "Fixed NodePort for the relay in OpenShift (HIVE_TURN_NODE_PORT); in Docker Compose the relay listens on 3478 itself.",
  "ih.turn.ck.fw": "Port 3478 forwarded over UDP and TCP on the HAProxy/firewall to the relay.",
  "ih.turn.ck.hc": "Health check of the load balancer on the relay port, and this test green on both transports.",
} as const;

type K = keyof typeof en;

const ptBR: Record<K, string> = {
  'nav.license': 'Licença',
  'audit.title': 'Trilha de auditoria',
  'audit.sub': 'Tudo o que foi feito na plataforma, com quem, quando, de onde e em qual objeto. Cada registro é encadeado ao anterior por um hash.',
  'audit.verify': 'Verificar o encadeamento',
  'audit.verifying': 'Recalculando o encadeamento de cada registro…',
  'audit.siem': 'Enviar para o SIEM',
  'audit.v.read': 'Ler {count} registros',
  'audit.v.chain': 'Recalcular o encadeamento por hash de cada registro',
  'audit.v.noBreak': 'Nenhuma quebra encontrada',
  'audit.v.brokenAt': 'Quebra encontrada no registro {id}',
  'audit.v.intact': 'Trilha íntegra: nenhum dos {count} registros foi alterado.',
  'audit.v.broken': 'O encadeamento está quebrado no registro {id}: um registro foi alterado fora do Hive. Guarde a evidência e fale com o provedor de serviços.',
  'audit.f.actor': 'Pessoa ou conta',
  'audit.f.actorPlaceholder': 'Ex.: marina.castro@aurora.example',
  'audit.f.action': 'Ação',
  'audit.f.target': 'Objeto',
  'audit.empty': 'Nenhum registro com estes filtros.',
  'audit.col.when': 'Data e hora',
  'audit.col.who': 'Quem',
  'audit.col.action': 'Ação',
  'audit.col.object': 'O quê',
  'audit.col.ip': 'Origem (IP)',
  'audit.col.chain': 'Encadeamento',
  'audit.note': 'Cada registro guarda a impressão digital do anterior. Qualquer alteração direta no banco quebra a corrente e aparece na verificação.',
  'audit.group.user': 'Pessoas',
  'audit.group.profile': 'Perfis',
  'audit.group.auth': 'Métodos de entrada',
  'audit.group.integration': 'Integrações',
  'audit.group.api-account': 'Contas de integração (API)',
  'audit.group.settings': 'Configurações da empresa',
  'audit.group.support': 'Acesso de suporte',
  'audit.group.config': 'Versões de configuração',
  'audit.group.group-mappings': 'Grupos do diretório',
  'audit.group.template': 'Modelos',
  'audit.target.user': 'Pessoa',
  'audit.target.profile': 'Perfil',
  'audit.target.auth-method': 'Método de entrada',
  'audit.target.integration': 'Integração',
  'audit.target.api-account': 'Conta de integração',
  'audit.target.settings': 'Configurações',
  'audit.target.support-request': 'Pedido de suporte',
  'audit.target.template': 'Modelo',
  'audit.target.tenant': 'Empresa',
  'audit.kind.integration': 'conta de integração',
  'audit.kind.provider': 'provedor de serviços',
  'audit.kind.system': 'sistema',
  'audit.action.user.invited': 'Pessoa convidada',
  'audit.action.user.invite-resent': 'Convite reenviado',
  'audit.action.user.first-login': 'Primeiro acesso',
  'audit.action.user.profiles-changed': 'Perfis de uma pessoa alterados',
  'audit.action.user.profile-switched': 'Perfil ativo trocado',
  'audit.action.user.disabled': 'Acesso desativado',
  'audit.action.user.enabled': 'Acesso religado',
  'audit.action.profile.created': 'Perfil criado',
  'audit.action.profile.updated': 'Perfil alterado',
  'audit.action.profile.deleted': 'Perfil excluído',
  'audit.action.config.restored': 'Versão restaurada',
  'audit.action.auth.method-enabled': 'Método de entrada ligado',
  'audit.action.auth.method-disabled': 'Método de entrada desligado',
  'audit.action.integration.connected': 'Integração conectada',
  'audit.action.integration.updated': 'Integração alterada',
  'audit.action.integration.disconnected': 'Integração desconectada',
  'audit.action.integration.use-enabled': 'Uso ligado',
  'audit.action.integration.use-disabled': 'Uso desligado',
  'audit.action.integration.consent-granted': 'Permissão extra concedida',
  'audit.action.integration.tested': 'Conexão testada',
  'audit.action.api-account.created': 'Conta de integração criada',
  'audit.action.api-account.rotated': 'Token trocado',
  'audit.action.api-account.revoked': 'Conta de integração revogada',
  'audit.action.settings.updated': 'Configurações da empresa alteradas',
  'audit.action.settings.logo-uploaded': 'Logotipo da empresa enviado',
  'audit.action.settings.logo-removed': 'Logotipo da empresa removido',
  'audit.action.settings.icon-uploaded': 'Ícone da marca enviado',
  'audit.action.settings.icon-removed': 'Ícone da marca removido',
  'audit.action.support.requested': 'Acesso de suporte pedido',
  'audit.action.support.approved': 'Acesso de suporte aprovado',
  'audit.action.support.denied': 'Acesso de suporte recusado ou revogado',
  'audit.action.support.call': 'Chamada feita em modo suporte',
  'audit.action.group-mappings.updated': 'Grupos do diretório alterados',
  'audit.action.template.duplicated': 'Modelo duplicado',
  'audit.action.tenant.created': 'Empresa criada',

  'settings.title': 'Configurações da empresa',
  'settings.sub': 'Marca e idioma padrão da empresa. A região dos dados e o plano são definidos pelo provedor de serviços.',
  'settings.brand': 'Marca',
  'settings.companyName': 'Nome da empresa',
  'settings.companyNameHint': 'Aparece na barra superior, no início e na página de entrada. Por enquanto é digitado aqui; depois virá da licença.',
  'settings.productName': 'Nome do produto exibido',
  'settings.productNameHint': 'Aparece na barra superior, na tela de entrada e na aba do navegador.',
  'settings.logo': 'Endereço do logotipo (opcional)',
  'settings.logoHint': 'Um endereço https:// de uma imagem PNG ou SVG. Sem logotipo, o nome do produto aparece em letras.',
  'settings.logoInvalid': 'Use um endereço que comece com https://',
  'settings.logoAfterSave': 'O logotipo novo aparece depois de salvar: o Hive busca neste endereço e serve pela própria console (PNG, JPEG, WebP, GIF ou SVG até 512 KB).',
  'settings.color': 'Cor principal',
  'settings.swatch': 'Cor {color}',
  'settings.other': 'Outra:',
  'settings.contrastLow': 'Contraste insuficiente com texto branco ({ratio}:1).',
  'settings.contrastFix': 'Botões e barra superior ficam difíceis de ler (mínimo AA: 4,5:1). A variação mais próxima que atende é {color}.',
  'settings.useSuggestion': 'Usar a variação sugerida',
  'settings.contrastOk': 'Contraste AA ok ({ratio}:1)',
  'settings.langTitle': 'Idioma',
  'settings.lang': 'Idioma padrão da empresa',
  'settings.langHint': 'Pessoas novas começam neste idioma; cada pessoa pode escolher outro no menu do usuário.',
  'settings.save': 'Salvar configurações',
  'settings.saveHint': 'A mudança vale na hora e vai para a trilha de auditoria.',
  'settings.saved': 'Configurações salvas.',
  'settings.undone': 'Configurações anteriores restauradas.',
  'settings.preview': 'Prévia ao vivo',
  'settings.previewHint': 'No modo escuro o Hive usa uma versão mais clara da cor para manter o contraste.',
  'settings.logoFull': 'Logotipo completo',
  'settings.logoFullHint': 'Imagem horizontal para a tela de entrada, os painéis e o cabeçalho dos relatórios em PDF. Recomendado: cerca de 600 x 150 px (4:1), PNG ou SVG com fundo transparente, até 512 KB.',
  'settings.icon': 'Ícone',
  'settings.iconHint': 'Imagem quadrada para o trilho de ícones e a aba do navegador. Recomendado: 256 x 256 px, PNG ou SVG, até 256 KB. Sem ícone, o trilho mostra a inicial do nome do produto sobre a cor da marca.',
  'settings.iconCurrent': 'Ícone atual',
  'settings.iconNone': 'Sem ícone: inicial do nome',
  'settings.iconRemove': 'Remover ícone',
  'settings.iconUploaded': 'Ícone enviado',
  'settings.iconRemoved': 'Ícone removido',
  'settings.iconTooBig': 'Use uma imagem de até 256 KB.',
  'settings.where': 'Onde cada imagem aparece',
  'settings.whereSignIn': 'Tela de entrada (logotipo completo)',
  'settings.whereSignInBtn': 'Entrar',
  'settings.whereRail': 'Trilho de ícones e aba do navegador (ícone)',
  'settings.whereRailIcon': 'Ícone da empresa',
  'settings.whereRailInitial': 'Sem ícone: inicial sobre a cor da marca',
  'settings.whereReport': 'Cabeçalho do relatório (logotipo completo)',
  'settings.whereReportTitle': 'Ativos por sistema operacional',
  'license.title': 'Licença',
  'license.sub': 'Modo de implantação, período de teste e os agentes permitidos pela licença desta instalação.',
  'license.mode': 'Modo de implantação',
  'license.mode.demo': 'Demonstração',
  'license.mode.trial': 'Teste',
  'license.mode.production': 'Produção',
  'license.state.demo': 'Instalação de demonstração: sem limite de agentes',
  'license.state.trial': 'Teste: faltam {days} dias',
  'license.state.grace': 'Teste terminado: faltam {days} dias de carência',
  'license.state.expired': 'Teste terminado: só leitura',
  'license.state.licensed': 'Licenciada',
  'license.state.unlicensed': 'Sem licença válida: só leitura',
  'license.installationId': 'ID da instalação',
  'license.installationIdHint': 'Informe este ID (ou o endereço da empresa) ao fabricante para receber uma chave amarrada a esta instalação.',
  'license.firstBoot': 'Instalada em',
  'license.trialEnds': 'Teste termina em',
  'license.graceEnds': 'Carência termina em',
  'license.usage': 'Agentes em uso',
  'license.usageOf': '{used} de {limit} agentes',
  'license.usageUnlimited': '{used} agentes (sem limite no modo demonstração)',
  'license.usageNear': 'Mais de 90% da licença está em uso. Providencie uma chave adicional antes de chegarem máquinas novas.',
  'license.usageFull': 'Todos os agentes permitidos estão em uso: agentes novos são recusados até você instalar uma chave adicional ou revogar agentes de máquinas que saíram. Os agentes instalados continuam funcionando.',
  'license.collectorNote': 'Coletores não ocupam licença.',
  'license.total': 'Total licenciado',
  'license.totalValue': '{count} agentes',
  'license.install': 'Instalar uma chave de licença',
  'license.serial': 'Chave de licença',
  'license.serialHint': 'Cole a chave inteira que o fabricante enviou, começando por HIVE1. Quebras de linha são ignoradas.',
  'license.installBtn': 'Instalar chave',
  'license.installing': 'Conferindo a chave…',
  'license.installed': 'Chave de licença instalada.',
  'license.notSerial': 'Isto não parece uma chave de licença: ela começa com HIVE1. e tem dois pontos.',
  'license.keys': 'Chaves instaladas',
  'license.noKeys': 'Nenhuma chave de licença instalada ainda.',
  'license.col.id': 'Licença',
  'license.col.licensee': 'Licenciado',
  'license.col.agents': 'Agentes',
  'license.col.kind': 'Tipo',
  'license.col.validUntil': 'Válida até',
  'license.col.state': 'Situação',
  'license.col.installed': 'Instalada',
  'license.kind.new': 'Nova',
  'license.kind.add-on': 'Adicional',
  'license.key.active': 'Ativa',
  'license.key.pending': 'Ainda não começou',
  'license.key.expired': 'Vencida',
  'license.key.replaced': 'Substituída',
  'license.replacedBy': 'Substituída por {id}',
  'license.startsOn': 'Começa em {date}',
  'license.perpetual': 'Sem vencimento',
  'license.adminOnly': 'Só administradores veem e instalam as chaves.',
  'license.readOnlyNote': 'Só leitura: os dados continuam disponíveis, mas agentes novos e mudanças ficam bloqueados até instalar uma licença válida.',
  'license.stackNote': 'Chaves válidas somam. Uma chave que substitui outra tira a antiga da conta.',
  'license.banner.demo': 'Instalação de demonstração: dados de laboratório, não use em produção.',
  'license.banner.trial': 'Teste: faltam {days} dias.',
  'license.banner.grace': 'O teste terminou. Faltam {days} dias de carência antes de o sistema ficar só leitura: instale uma licença.',
  'license.banner.expired': 'O teste terminou e o sistema está só leitura: instale uma licença para incluir agentes e fazer mudanças.',
  'license.banner.unlicensed': 'Esta instalação não tem licença válida e está só leitura: instale uma chave de licença.',
  'license.banner.full': 'Licença cheia: {used} de {limit} agentes em uso. Agentes novos são recusados.',
  'license.banner.near': 'Licença quase cheia: {used} de {limit} agentes em uso.',
  'license.banner.open': 'Ver a licença',
  'audit.action.license.installed': 'Chave de licença instalada',
  'audit.action.deployment.mode-changed': 'Modo de implantação alterado',
  "settings.logoUpload": "Enviar imagem",
  "settings.logoReplace": "Trocar imagem",
  "settings.logoRemove": "Remover",
  "settings.logoCurrent": "Logotipo atual",
  "settings.logoFileHint": "PNG, JPEG, WebP ou SVG de até 512 KB. Vale na hora, também na tela de entrada.",
  "settings.logoOrUrl": "Ou endereço do logotipo (https)",
  "settings.logoUploaded": "Logotipo enviado",
  "settings.logoRemoved": "Logotipo removido",
  "settings.logoTooBig": "Use uma imagem de até 512 KB.",
  "users.tab.teams": "Equipes",
  "teams.lead": "Grupos de pessoas para compartilhar painéis com quem trabalha junto.",
  "teams.new": "Nova equipe",
  "teams.empty": "Nenhuma equipe ainda",
  "teams.emptyText": "Crie uma equipe para compartilhar painéis com várias pessoas de uma vez.",
  "teams.col.name": "Nome",
  "teams.col.members": "Pessoas",
  "teams.col.people": "Quem",
  "teams.col.actions": "Ações",
  "teams.edit": "Editar",
  "teams.delete": "Excluir",
  "teams.deleted": "Equipe excluída",
  "teams.deleteTitle": "Excluir a equipe {name}?",
  "teams.deleteText": "Os painéis compartilhados com esta equipe deixam de aparecer para as pessoas dela (a não ser que estejam compartilhados com elas diretamente).",
  "teams.editTitle": "Equipe {name}",
  "teams.description": "Descrição",
  "teams.members": "Pessoas na equipe ({n})",
  "teams.searchPeople": "Procurar pessoas",
  "teams.save": "Salvar",
  "teams.saved": "Equipe salva",
  "rp.d.sharePeople": "Pessoas e equipes que eu escolher",
  "rp.d.teams": "Equipes ({n})",
  "rp.d.people": "Pessoas ({n})",
  "rp.d.noTeams": "Nenhuma equipe ainda: crie em Admin › Pessoas › Equipes.",
  "rp.d.searchPeople": "Procurar pessoas",
  // G10
  "audit.evidence": "Pacote de evidências",
  "audit.evidenceText": "ZIP assinado para auditores de SOC 2 / ISO 27001: a trilha encadeada do período com a verificação da cadeia, as mudanças de configuração, os acessos privilegiados (suporte do provedor, dupla aprovação, segredos revelados, MFA), a revisão de acessos atual e cada backup com o sha256. O manifesto é assinado com Ed25519.",
  "audit.evidenceFrom": "De",
  "audit.evidenceTo": "Até",
  "audit.evidenceDate": "Use AAAA-MM-DD.",
  "audit.evidenceRun": "Gerar pacote assinado",
  "audit.evidenceBusy": "Gerando…",
  "audit.evidenceDone": "Pacote de evidências baixado. A exportação foi para a trilha.",
  "scope.control-plane": "Plano de controle do provedor (instância gerenciada: status, uso, pedidos de suporte)",
  "nav.health": "Saúde da instalação",
  "ih.title": "Saúde da instalação",
  "ih.sub": "Testes do que esta instalação precisa da infraestrutura, feitos a partir do núcleo.",
  "ih.turn.title": "Relé do acesso remoto (TURN)",
  "ih.turn.lead": "O acesso remoto só conecta pelo relé. O teste pede uma alocação TURN em cada endereço publicado, por UDP e por TCP, com a mesma credencial de curta duração que a console e o agente usam.",
  "ih.turn.published": "Endereços publicados",
  "ih.turn.run": "Testar o relé",
  "ih.turn.running": "Testando…",
  "ih.turn.off": "O acesso remoto está desligado nesta instalação (relé turn-desativado.invalid). Para ligar, siga o checklist de infraestrutura abaixo.",
  "ih.turn.col.address": "Endereço",
  "ih.turn.col.port": "A porta responde",
  "ih.turn.col.alloc": "Alocação TURN",
  "ih.turn.col.detail": "Detalhe",
  "ih.turn.yes": "Sim",
  "ih.turn.no": "Não",
  "ih.turn.allocated": "Alocado em {ms} ms",
  "ih.turn.failed": "Falhou",
  "ih.turn.relayed": "endereço do relé {a}",
  "ih.turn.allOk": "O relé responde por UDP e por TCP: o acesso remoto consegue conectar.",
  "ih.turn.partial": "Parte dos endereços do relé falhou: as sessões podem terminar em \"falha de conexão\". Veja o detalhe de cada linha.",
  "ih.turn.at": "Testado {when}.",
  "ih.turn.checklist": "Checklist de infraestrutura",
  "ih.turn.ck.name": "Nome público ou IP para o relé (HIVE_TURN_HOST), alcançável pelos navegadores dos técnicos e pelos agentes.",
  "ih.turn.ck.port": "NodePort fixa para o relé no OpenShift (HIVE_TURN_NODE_PORT); no Docker Compose o relé escuta na própria 3478.",
  "ih.turn.ck.fw": "Porta 3478 encaminhada por UDP e TCP no HAProxy/firewall até o relé.",
  "ih.turn.ck.hc": "Health check do balanceador na porta do relé, e este teste verde nos dois transportes.",
};

const es: Record<K, string> = {
  'nav.license': 'Licencia',
  'audit.title': 'Registro de auditoría',
  'audit.sub': 'Todo lo que se hizo en la plataforma, con quién, cuándo, desde dónde y sobre qué objeto. Cada registro está encadenado al anterior por un hash.',
  'audit.verify': 'Verificar el encadenamiento',
  'audit.verifying': 'Recalculando el encadenamiento de cada registro…',
  'audit.siem': 'Enviar al SIEM',
  'audit.v.read': 'Leer {count} registros',
  'audit.v.chain': 'Recalcular el encadenamiento por hash de cada registro',
  'audit.v.noBreak': 'No se encontró ninguna ruptura',
  'audit.v.brokenAt': 'Ruptura encontrada en el registro {id}',
  'audit.v.intact': 'Registro íntegro: ninguno de los {count} registros fue alterado.',
  'audit.v.broken': 'El encadenamiento está roto en el registro {id}: un registro fue alterado fuera de Hive. Guarde la evidencia y contacte al proveedor de servicios.',
  'audit.f.actor': 'Persona o cuenta',
  'audit.f.actorPlaceholder': 'P. ej. marina.castro@aurora.example',
  'audit.f.action': 'Acción',
  'audit.f.target': 'Objeto',
  'audit.empty': 'No hay registros con estos filtros.',
  'audit.col.when': 'Fecha y hora',
  'audit.col.who': 'Quién',
  'audit.col.action': 'Acción',
  'audit.col.object': 'Qué',
  'audit.col.ip': 'Origen (IP)',
  'audit.col.chain': 'Encadenamiento',
  'audit.note': 'Cada registro guarda la huella del anterior. Cualquier cambio directo en la base de datos rompe la cadena y aparece en la verificación.',
  'audit.group.user': 'Personas',
  'audit.group.profile': 'Perfiles',
  'audit.group.auth': 'Métodos de inicio de sesión',
  'audit.group.integration': 'Integraciones',
  'audit.group.api-account': 'Cuentas de integración (API)',
  'audit.group.settings': 'Configuración de la empresa',
  'audit.group.support': 'Acceso de soporte',
  'audit.group.config': 'Versiones de configuración',
  'audit.group.group-mappings': 'Grupos del directorio',
  'audit.group.template': 'Plantillas',
  'audit.target.user': 'Persona',
  'audit.target.profile': 'Perfil',
  'audit.target.auth-method': 'Método de inicio de sesión',
  'audit.target.integration': 'Integración',
  'audit.target.api-account': 'Cuenta de integración',
  'audit.target.settings': 'Configuración',
  'audit.target.support-request': 'Solicitud de soporte',
  'audit.target.template': 'Plantilla',
  'audit.target.tenant': 'Empresa',
  'audit.kind.integration': 'cuenta de integración',
  'audit.kind.provider': 'proveedor de servicios',
  'audit.kind.system': 'sistema',
  'audit.action.user.invited': 'Persona invitada',
  'audit.action.user.invite-resent': 'Invitación reenviada',
  'audit.action.user.first-login': 'Primer acceso',
  'audit.action.user.profiles-changed': 'Perfiles de una persona cambiados',
  'audit.action.user.profile-switched': 'Perfil activo cambiado',
  'audit.action.user.disabled': 'Acceso desactivado',
  'audit.action.user.enabled': 'Acceso reactivado',
  'audit.action.profile.created': 'Perfil creado',
  'audit.action.profile.updated': 'Perfil cambiado',
  'audit.action.profile.deleted': 'Perfil eliminado',
  'audit.action.config.restored': 'Versión restaurada',
  'audit.action.auth.method-enabled': 'Método de inicio de sesión activado',
  'audit.action.auth.method-disabled': 'Método de inicio de sesión desactivado',
  'audit.action.integration.connected': 'Integración conectada',
  'audit.action.integration.updated': 'Integración cambiada',
  'audit.action.integration.disconnected': 'Integración desconectada',
  'audit.action.integration.use-enabled': 'Uso activado',
  'audit.action.integration.use-disabled': 'Uso desactivado',
  'audit.action.integration.consent-granted': 'Permiso adicional concedido',
  'audit.action.integration.tested': 'Conexión probada',
  'audit.action.api-account.created': 'Cuenta de integración creada',
  'audit.action.api-account.rotated': 'Token cambiado',
  'audit.action.api-account.revoked': 'Cuenta de integración revocada',
  'audit.action.settings.updated': 'Configuración de la empresa cambiada',
  'audit.action.settings.logo-uploaded': 'Logotipo de la empresa subido',
  'audit.action.settings.logo-removed': 'Logotipo de la empresa quitado',
  'audit.action.settings.icon-uploaded': 'Ícono de la marca subido',
  'audit.action.settings.icon-removed': 'Ícono de la marca quitado',
  'audit.action.support.requested': 'Acceso de soporte solicitado',
  'audit.action.support.approved': 'Acceso de soporte aprobado',
  'audit.action.support.denied': 'Acceso de soporte rechazado o revocado',
  'audit.action.support.call': 'Llamada hecha en modo soporte',
  'audit.action.group-mappings.updated': 'Grupos del directorio cambiados',
  'audit.action.template.duplicated': 'Plantilla duplicada',
  'audit.action.tenant.created': 'Empresa creada',

  'settings.title': 'Configuración de la empresa',
  'settings.sub': 'Marca e idioma predeterminado de la empresa. La región de los datos y el plan los define el proveedor de servicios.',
  'settings.brand': 'Marca',
  'settings.companyName': 'Nombre de la empresa',
  'settings.companyNameHint': 'Aparece en la barra superior, en el inicio y en la página de acceso. Por ahora se escribe aquí; después vendrá de la licencia.',
  'settings.productName': 'Nombre del producto mostrado',
  'settings.productNameHint': 'Aparece en la barra superior, en la pantalla de inicio de sesión y en la pestaña del navegador.',
  'settings.logo': 'Dirección del logotipo (opcional)',
  'settings.logoHint': 'Una dirección https:// de una imagen PNG o SVG. Sin logotipo, el nombre del producto aparece en letras.',
  'settings.logoInvalid': 'Use una dirección que empiece con https://',
  'settings.logoAfterSave': 'El logotipo nuevo aparece después de guardar: Hive lo busca en esta dirección y lo sirve desde la propia consola (PNG, JPEG, WebP, GIF o SVG hasta 512 KB).',
  'settings.color': 'Color principal',
  'settings.swatch': 'Color {color}',
  'settings.other': 'Otro:',
  'settings.contrastLow': 'Contraste insuficiente con texto blanco ({ratio}:1).',
  'settings.contrastFix': 'Los botones y la barra superior son difíciles de leer (mínimo AA: 4,5:1). La variación más cercana que cumple es {color}.',
  'settings.useSuggestion': 'Usar la variación sugerida',
  'settings.contrastOk': 'Contraste AA correcto ({ratio}:1)',
  'settings.langTitle': 'Idioma',
  'settings.lang': 'Idioma predeterminado de la empresa',
  'settings.langHint': 'Las personas nuevas empiezan en este idioma; cada persona puede elegir otro en el menú del usuario.',
  'settings.save': 'Guardar configuración',
  'settings.saveHint': 'El cambio vale de inmediato y va al registro de auditoría.',
  'settings.saved': 'Configuración guardada.',
  'settings.undone': 'Configuración anterior restaurada.',
  'settings.preview': 'Vista previa en vivo',
  'settings.previewHint': 'En el modo oscuro Hive usa una versión más clara del color para mantener el contraste.',
  'settings.logoFull': 'Logotipo completo',
  'settings.logoFullHint': 'Imagen horizontal para la pantalla de inicio de sesión, los paneles y el encabezado de los informes en PDF. Recomendado: unos 600 x 150 px (4:1), PNG o SVG con fondo transparente, hasta 512 KB.',
  'settings.icon': 'Ícono',
  'settings.iconHint': 'Imagen cuadrada para la barra de íconos y la pestaña del navegador. Recomendado: 256 x 256 px, PNG o SVG, hasta 256 KB. Sin ícono, la barra muestra la inicial del nombre del producto sobre el color de la marca.',
  'settings.iconCurrent': 'Ícono actual',
  'settings.iconNone': 'Sin ícono: inicial del nombre',
  'settings.iconRemove': 'Quitar ícono',
  'settings.iconUploaded': 'Ícono subido',
  'settings.iconRemoved': 'Ícono quitado',
  'settings.iconTooBig': 'Use una imagen de hasta 256 KB.',
  'settings.where': 'Dónde aparece cada imagen',
  'settings.whereSignIn': 'Pantalla de inicio de sesión (logotipo completo)',
  'settings.whereSignInBtn': 'Iniciar sesión',
  'settings.whereRail': 'Barra de íconos y pestaña del navegador (ícono)',
  'settings.whereRailIcon': 'Ícono de la empresa',
  'settings.whereRailInitial': 'Sin ícono: inicial sobre el color de la marca',
  'settings.whereReport': 'Encabezado del informe (logotipo completo)',
  'settings.whereReportTitle': 'Activos por sistema operativo',
  'license.title': 'Licencia',
  'license.sub': 'Modo de implementación, período de prueba y los agentes permitidos por la licencia de esta instalación.',
  'license.mode': 'Modo de implementación',
  'license.mode.demo': 'Demostración',
  'license.mode.trial': 'Prueba',
  'license.mode.production': 'Producción',
  'license.state.demo': 'Instalación de demostración: sin límite de agentes',
  'license.state.trial': 'Prueba: quedan {days} días',
  'license.state.grace': 'Prueba terminada: quedan {days} días de gracia',
  'license.state.expired': 'Prueba terminada: solo lectura',
  'license.state.licensed': 'Con licencia',
  'license.state.unlicensed': 'Sin licencia válida: solo lectura',
  'license.installationId': 'ID de la instalación',
  'license.installationIdHint': 'Informe este ID (o la dirección de la empresa) al fabricante para recibir una clave vinculada a esta instalación.',
  'license.firstBoot': 'Instalada el',
  'license.trialEnds': 'La prueba termina el',
  'license.graceEnds': 'La gracia termina el',
  'license.usage': 'Agentes en uso',
  'license.usageOf': '{used} de {limit} agentes',
  'license.usageUnlimited': '{used} agentes (sin límite en modo demostración)',
  'license.usageNear': 'Más del 90% de la licencia está en uso. Prevea una clave adicional antes de que lleguen equipos nuevos.',
  'license.usageFull': 'Todos los agentes permitidos están en uso: los agentes nuevos se rechazan hasta que instale una clave adicional o revoque agentes de equipos que ya no están. Los agentes instalados siguen funcionando.',
  'license.collectorNote': 'Los colectores no ocupan licencia.',
  'license.total': 'Total con licencia',
  'license.totalValue': '{count} agentes',
  'license.install': 'Instalar una clave de licencia',
  'license.serial': 'Clave de licencia',
  'license.serialHint': 'Pegue la clave completa que envió el fabricante, empezando por HIVE1. Los saltos de línea se ignoran.',
  'license.installBtn': 'Instalar clave',
  'license.installing': 'Verificando la clave…',
  'license.installed': 'Clave de licencia instalada.',
  'license.notSerial': 'Esto no parece una clave de licencia: empieza con HIVE1. y tiene dos puntos.',
  'license.keys': 'Claves instaladas',
  'license.noKeys': 'Todavía no hay ninguna clave de licencia instalada.',
  'license.col.id': 'Licencia',
  'license.col.licensee': 'Licenciatario',
  'license.col.agents': 'Agentes',
  'license.col.kind': 'Tipo',
  'license.col.validUntil': 'Válida hasta',
  'license.col.state': 'Estado',
  'license.col.installed': 'Instalada',
  'license.kind.new': 'Nueva',
  'license.kind.add-on': 'Adicional',
  'license.key.active': 'Activa',
  'license.key.pending': 'Aún no empezó',
  'license.key.expired': 'Vencida',
  'license.key.replaced': 'Reemplazada',
  'license.replacedBy': 'Reemplazada por {id}',
  'license.startsOn': 'Empieza el {date}',
  'license.perpetual': 'Sin vencimiento',
  'license.adminOnly': 'Solo los administradores ven e instalan las claves.',
  'license.readOnlyNote': 'Solo lectura: los datos siguen disponibles, pero los agentes nuevos y los cambios quedan bloqueados hasta instalar una licencia válida.',
  'license.stackNote': 'Las claves válidas se suman. Una clave que reemplaza a otra saca la anterior de la cuenta.',
  'license.banner.demo': 'Instalación de demostración: datos de laboratorio, no la use en producción.',
  'license.banner.trial': 'Prueba: quedan {days} días.',
  'license.banner.grace': 'La prueba terminó. Quedan {days} días de gracia antes de que el sistema quede en solo lectura: instale una licencia.',
  'license.banner.expired': 'La prueba terminó y el sistema está en solo lectura: instale una licencia para agregar agentes y hacer cambios.',
  'license.banner.unlicensed': 'Esta instalación no tiene una licencia válida y está en solo lectura: instale una clave de licencia.',
  'license.banner.full': 'Licencia completa: {used} de {limit} agentes en uso. Los agentes nuevos se rechazan.',
  'license.banner.near': 'Licencia casi completa: {used} de {limit} agentes en uso.',
  'license.banner.open': 'Ver la licencia',
  'audit.action.license.installed': 'Clave de licencia instalada',
  'audit.action.deployment.mode-changed': 'Modo de implementación cambiado',
  "settings.logoUpload": "Subir imagen",
  "settings.logoReplace": "Cambiar imagen",
  "settings.logoRemove": "Quitar",
  "settings.logoCurrent": "Logotipo actual",
  "settings.logoFileHint": "PNG, JPEG, WebP o SVG de hasta 512 KB. Se aplica al instante, también en la pantalla de acceso.",
  "settings.logoOrUrl": "O dirección del logotipo (https)",
  "settings.logoUploaded": "Logotipo enviado",
  "settings.logoRemoved": "Logotipo quitado",
  "settings.logoTooBig": "Use una imagen de hasta 512 KB.",
  "users.tab.teams": "Equipos",
  "teams.lead": "Grupos de personas para compartir paneles con quien trabaja junto.",
  "teams.new": "Nuevo equipo",
  "teams.empty": "Aún no hay equipos",
  "teams.emptyText": "Cree un equipo para compartir paneles con varias personas a la vez.",
  "teams.col.name": "Nombre",
  "teams.col.members": "Personas",
  "teams.col.people": "Quién",
  "teams.col.actions": "Acciones",
  "teams.edit": "Editar",
  "teams.delete": "Eliminar",
  "teams.deleted": "Equipo eliminado",
  "teams.deleteTitle": "¿Eliminar el equipo {name}?",
  "teams.deleteText": "Los paneles compartidos con este equipo dejan de mostrarse a sus personas (salvo que se compartan con ellas directamente).",
  "teams.editTitle": "Equipo {name}",
  "teams.description": "Descripción",
  "teams.members": "Personas en el equipo ({n})",
  "teams.searchPeople": "Buscar personas",
  "teams.save": "Guardar",
  "teams.saved": "Equipo guardado",
  "rp.d.sharePeople": "Personas y equipos que elija",
  "rp.d.teams": "Equipos ({n})",
  "rp.d.people": "Personas ({n})",
  "rp.d.noTeams": "Aún no hay equipos: créelos en Admin › Personas › Equipos.",
  "rp.d.searchPeople": "Buscar personas",
  // G10
  "audit.evidence": "Paquete de evidencias",
  "audit.evidenceText": "ZIP firmado para auditores de SOC 2 / ISO 27001: el registro encadenado del período con la verificación de la cadena, los cambios de configuración, los accesos privilegiados (soporte del proveedor, doble aprobación, secretos revelados, MFA), la revisión de accesos actual y cada respaldo con su sha256. El manifiesto está firmado con Ed25519.",
  "audit.evidenceFrom": "Desde",
  "audit.evidenceTo": "Hasta",
  "audit.evidenceDate": "Use AAAA-MM-DD.",
  "audit.evidenceRun": "Generar paquete firmado",
  "audit.evidenceBusy": "Generando…",
  "audit.evidenceDone": "Paquete de evidencias descargado. La exportación quedó en el registro de auditoría.",
  "scope.control-plane": "Plano de control del proveedor (instancia gestionada: estado, uso, solicitudes de soporte)",
  "nav.health": "Salud de la instalación",
  "ih.title": "Salud de la instalación",
  "ih.sub": "Pruebas de lo que esta instalación necesita de la infraestructura, hechas desde el núcleo.",
  "ih.turn.title": "Relé del acceso remoto (TURN)",
  "ih.turn.lead": "El acceso remoto solo conecta a través del relé. La prueba pide una asignación TURN en cada dirección publicada, por UDP y por TCP, con la misma credencial de corta duración que usan la consola y el agente.",
  "ih.turn.published": "Direcciones publicadas",
  "ih.turn.run": "Probar el relé",
  "ih.turn.running": "Probando…",
  "ih.turn.off": "El acceso remoto está desactivado en esta instalación (relé turn-desativado.invalid). Para activarlo, siga la lista de verificación de infraestructura de abajo.",
  "ih.turn.col.address": "Dirección",
  "ih.turn.col.port": "El puerto responde",
  "ih.turn.col.alloc": "Asignación TURN",
  "ih.turn.col.detail": "Detalle",
  "ih.turn.yes": "Sí",
  "ih.turn.no": "No",
  "ih.turn.allocated": "Asignado en {ms} ms",
  "ih.turn.failed": "Falló",
  "ih.turn.relayed": "dirección del relé {a}",
  "ih.turn.allOk": "El relé responde por UDP y por TCP: el acceso remoto puede conectar.",
  "ih.turn.partial": "Parte de las direcciones del relé falló: las sesiones pueden terminar en \"falla de conexión\". Vea el detalle de cada línea.",
  "ih.turn.at": "Probado {when}.",
  "ih.turn.checklist": "Lista de verificación de infraestructura",
  "ih.turn.ck.name": "Nombre público o IP para el relé (HIVE_TURN_HOST), alcanzable por los navegadores de los técnicos y por los agentes.",
  "ih.turn.ck.port": "NodePort fijo para el relé en OpenShift (HIVE_TURN_NODE_PORT); en Docker Compose el relé escucha en el propio 3478.",
  "ih.turn.ck.fw": "Puerto 3478 reenviado por UDP y TCP en el HAProxy/firewall hasta el relé.",
  "ih.turn.ck.hc": "Health check del balanceador en el puerto del relé, y esta prueba en verde en los dos transportes.",
};

export const adminMessages = { en, 'pt-BR': ptBR, es } as const;
